import { SitePagesState } from './sitePagesState.js';
import path from 'path';
import { getPageId } from '../document/utils/wmlUtils.js';
const getFoldersInPath = async (siteFileSystem, dirPath) => {
    const entries = await siteFileSystem.readFolder(dirPath);
    return entries.filter(entry => entry.isDirectory()).map(({ name }) => name);
};
const getMatchingPaths = (folderName, paths) => paths.filter(([first]) => first?.type === 'DynamicFolder' || first.name === folderName);
const isNonEmptyFolder = async (siteFileSystem, folderPath) => {
    const entries = await siteFileSystem.readFolder(folderPath);
    return entries.length > 0;
};
const filterAsync = async (arr, predicate) => {
    const results = await Promise.all(arr.map(predicate));
    return arr.filter((_, index) => results[index]);
};
const getPages = async (siteFileSystem, paths, rootPath = '') => {
    if (paths.length === 0)
        return [];
    const result = [];
    const rootFolders = await getFoldersInPath(siteFileSystem, rootPath);
    for (const folderName of rootFolders) {
        const matchingPaths = getMatchingPaths(folderName, paths);
        if (matchingPaths.length > 0) {
            const finalPaths = await filterAsync(matchingPaths.filter(p => p.length === 1).map(() => path.join(rootPath, folderName)), folderPath => isNonEmptyFolder(siteFileSystem, folderPath));
            const nonFinalPaths = matchingPaths.filter(p => p.length > 1).map(([, ...rest]) => rest);
            const nestedPages = await getPages(siteFileSystem, nonFinalPaths, path.join(rootPath, folderName));
            result.push(...finalPaths, ...nestedPages);
        }
    }
    return result;
};
const getAllPageFolders = async (siteFileStructure, siteFileSystem) => {
    const paths = siteFileStructure.getPagesPaths();
    return await getPages(siteFileSystem, Object.values(paths));
};
export const buildPagesState = async (siteFileStructure, siteFileSystem) => {
    const state = new SitePagesState();
    const pagesFolders = await getAllPageFolders(siteFileStructure, siteFileSystem);
    await Promise.all(pagesFolders.map(async (folderPath) => {
        const filePaths = siteFileStructure.getPageFilesPaths(folderPath);
        const pageId = await getPageId(siteFileSystem, filePaths.document);
        state.addPage(pageId, folderPath);
    }));
    return state;
};
